import {useState} from "react";
import {Button, Group, Loader, Text} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import {bffApi} from "../../bffApi";
import ThreadButtonMenu from "./ThreadButtonMenu";
import IconDots from "../../../../assets/dots.svg?react";
import classes from "./ThreadButton.module.css";

interface Props {
    id: string;
    name: string;
    onClick: (id: string) => void;
    isSelected: boolean;
    isLoading: boolean;
    isCompleted?: boolean;
}

export const ThreadButton: React.FC<Props> = ({
    id,
    name,
    onClick,
    isSelected,
    isLoading,
    isCompleted = false,
}) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);
    const navigate = useNavigate();
    const [trackOpened] = bffApi.endpoints.trackOpened.useMutation();

    const handleClick = () => {
        trackOpened({entity: "thread", key: id, source: "sidebar"});
        navigate(`/chat/${id}`);
        onClick(id);
    };

    return (
        <Button
            className={`${classes.button} ${menuOpen ? classes.expanded : ""} ${
                isSelected ? classes.selected : ""
            } ${isLoading && isSelected ? classes.loading : ""} ${
                isLoading ? classes.streaming : ""
            }`}
            classNames={{section: classes.section, label: classes.label}}
            variant="subtle"
            size="xs"
            px="xs"
            rightSection={
                isLoading ? (
                    <Loader
                        size={12}
                        color="white"
                        type="oval"
                        aria-label="generating"
                    />
                ) : (
                    <ThreadButtonMenu
                        id={id}
                        name={name}
                        onOpen={() => setMenuOpen(true)}
                        onClose={() => setMenuOpen(false)}
                    >
                        <div onClick={(e) => e.stopPropagation()}>
                            <IconDots style={{color: "white"}} width={16} />
                        </div>
                    </ThreadButtonMenu>
                )
            }
            onClick={handleClick}
        >
            <Group gap="xs" wrap="nowrap" className={classes.text}>
                {!isLoading && isCompleted && (
                    <span
                        aria-label="new response"
                        style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "var(--mantine-color-blue-5)",
                            flex: "0 0 auto",
                        }}
                    />
                )}
                <Text fz="sm" truncate>
                    {name}
                </Text>
            </Group>
        </Button>
    );
};
